import i18n from '@/lang';
/* unplugin-vue-components disabled */
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "page-login"
  }, [_c('div', {
    staticClass: "login-img"
  }), _c('div', {
    staticClass: "lodin-content"
  }, [_c('img', {
    staticClass: "login-logo",
    attrs: {
      "src": _vm.epImg || "/static/toc/mobile/img/logo_danxiaoer_1.png"
    }
  }), _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.user.epName || ''))]), _c('div', {
    staticClass: "title"
  }, [_vm._v(i18n.tc("182"))])]), _c('div', {
    staticClass: "login-box"
  }, [_c('div', {
    staticClass: "login-input-box"
  }, [_c('img', {
    staticClass: "input-icon",
    attrs: {
      "src": "/static/toc/mobile/img/denglu-02.png"
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.phone,
      expression: "phone"
    }],
    staticClass: "input-class font-size-h3-large",
    attrs: {
      "type": "text",
      "placeholder": i18n.tc("183")
    },
    domProps: {
      "value": _vm.phone
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) {
          return;
        }
        _vm.phone = $event.target.value;
      }
    }
  })]), _c('div', {
    staticClass: "login-input-box"
  }, [_c('img', {
    staticClass: "input-icon",
    attrs: {
      "src": "/static/toc/mobile/img/denglu-03.png"
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.password,
      expression: "password"
    }],
    staticClass: "input-class font-size-h3-large",
    attrs: {
      "type": "password",
      "placeholder": i18n.tc("184")
    },
    domProps: {
      "value": _vm.password
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) {
          return;
        }
        _vm.password = $event.target.value;
      }
    }
  })]), _c('div', {
    staticClass: "login-input-box"
  }, [_c('img', {
    staticClass: "input-icon",
    attrs: {
      "src": "/static/toc/mobile/img/denglu-03.png"
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.verifyPassword,
      expression: "verifyPassword"
    }],
    staticClass: "input-class font-size-h3-large",
    attrs: {
      "type": "password",
      "placeholder": i18n.tc("185")
    },
    domProps: {
      "value": _vm.verifyPassword
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) {
          return;
        }
        _vm.verifyPassword = $event.target.value;
      }
    }
  })]), _c('div', {
    staticClass: "login-input-box"
  }, [_c('img', {
    staticClass: "input-icon",
    attrs: {
      "src": "/static/toc/mobile/img/denglu-04.png"
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.verify_code,
      expression: "verify_code"
    }],
    staticClass: "input-class font-size-h3-large verify-input",
    attrs: {
      "type": "number",
      "maxlength": "4",
      "placeholder": i18n.tc("177")
    },
    domProps: {
      "value": _vm.verify_code
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) {
          return;
        }
        _vm.verify_code = $event.target.value;
      }
    }
  }), _c('x-button', {
    staticClass: "get-verify-btn",
    attrs: {
      "mini": "",
      "disabled": _vm.wait <= 60
    },
    nativeOn: {
      "click": function ($event) {
        return _vm.getVerify.apply(null, arguments);
      }
    }
  }, [_c('font', {
    staticClass: "get-verify-text"
  }, [_vm._v(i18n.tc("186") + _vm._s(_vm.wait < 60 && _vm.wait > 0 ? "(" + _vm.wait + ")" : ''))])], 1)], 1), _c('x-button', {
    staticClass: "login-btn",
    attrs: {
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function ($event) {
        return _vm.submit.apply(null, arguments);
      }
    }
  }, [_vm._v(" " + _vm._s(Number(_vm.type) === 2 ? i18n.tc("187") : i18n.tc("7")) + " ")]), _c('router-link', {
    staticStyle: {
      "color": "#169bd5"
    },
    attrs: {
      "to": ""
    }
  }, [_c('span', {
    on: {
      "click": function ($event) {
        return _vm.$router.go(-1);
      }
    }
  }, [_vm._v(i18n.tc("188"))])])], 1)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };